import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Sorter from './Sorter';
import s from './NameColumnSorter.module.css';
import { getGradebook, updateGradebook } from '../../../../actions/gradebook';
import { GRADEBOOK_SORT } from '../../../../utils/constants';

// TODO Fix Lint Error
// eslint-disable-next-line react/prefer-stateless-function
class NameColumnSorter extends PureComponent {
  static propTypes = {
    dispatch: PropTypes.func,
    courseId: PropTypes.string,
    sortColumn: PropTypes.string,
    sortDirection: PropTypes.string,
    sortColumnHistory: PropTypes.arrayOf(PropTypes.string),
    search: PropTypes.string,
  };

  render() {
    const { dispatch, search } = this.props;
    const { courseId, sortColumn, sortDirection, sortColumnHistory } =
      this.props;
    const searchParams = new URLSearchParams(search);
    const ariaSettings = {
      key: 'columnNameSorter',
      description: 'Student Name',
    };
    const limitSizeHistory = 2;
    return (
      <div className={s.nameColumnSorter}>
        <b>Name</b>
        <span className={s.sorterContainer} data-test-id="student-column-sort">
          <Sorter
            active={
              sortColumn === GRADEBOOK_SORT.NAME_SORT_COLUMN &&
              !searchParams.get('studentSortKey')
            }
            sortDirection={sortDirection}
            handleSort={(newSortDirection) => {
              dispatch(
                getGradebook(courseId, {
                  studentSortDirection: newSortDirection,
                  iconSortDirection: newSortDirection,
                  studentSortKey: null, // related to the comment in method getNewStateSortOptions() client/src/actions/gradebook/getGradebook.js
                  page: 1,
                }),
              );
              dispatch(
                updateGradebook({
                  page: 1,
                  sortColumn: GRADEBOOK_SORT.NAME_SORT_COLUMN,
                  sortDirection: newSortDirection,
                  sortColumnHistory: [
                    ...sortColumnHistory.slice(
                      sortColumnHistory.length - limitSizeHistory,
                      sortColumnHistory.length,
                    ),
                    GRADEBOOK_SORT.NAME_SORT_COLUMN,
                  ],
                }),
              );
            }}
            ariaSettings={ariaSettings}
          />
        </span>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const searchParams = new URLSearchParams(window.location.search);
  const studentSortKeyURL = searchParams.get('studentSortKey');
  const history = state.gradebook.sortColumnHistory;

  if (history.length === 1 && studentSortKeyURL) {
    history.push(studentSortKeyURL);
  }

  return {
    courseId: state.gradebook.courseId,
    sortColumn: state.gradebook.sortColumn,
    sortDirection: state.gradebook.sortDirection,
    sortColumnHistory: history,
  };
};

const mapDispatchToProps = (dispatch) => ({ dispatch });

export default connect(mapStateToProps, mapDispatchToProps)(NameColumnSorter);
